'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILES = exports.FILES = 'FILES';
var EMAIL_METADATA = exports.EMAIL_METADATA = 'EMAIL_METADATA';
var QUICK_REPLIES = exports.QUICK_REPLIES = 'QUICK_REPLIES';